<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          :placeholder="$t('PersianName')"
          v-model="model.name"
          name="persianName"
          :label="$t('PersianName')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('persianName')">{{
          errors.first("persianName")
        }}</span>

        <label class="vs-select--label">{{ $t("Category") }}</label>
        <v-select
          label="name"
          name="cat"
          :options="allCategories"
          :reduce="(x) => x.id"
          v-model="model.categoryId"
          v-validate="{ required: true }"
          ref="categorySelect"
          class="mb-4"
          dir="rtl"
        >
        </v-select>
        <span class="text-danger text-sm mt-4" v-show="errors.has('cat')">{{
          errors.first("cat")
        }}</span>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";

const dict = {
  custom: {
    persianName: {
      required: "لطفا نام دسته را وارد نمایید.",
    },
    cat: {
      required: "لطفا دپارتمان را انتخاب نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      popupTitle: "",
      name: "",
      categoryId: null,
      disabled: false,
    };
  },
  computed: {
    ...mapGetters({
      allCategories: "category/list",
    }),

    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createGenericProduct: "genericProduct/create",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          this.createGenericProduct(this.model).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.popupTitle = "CreateNewGenericProduct";
      } else {
        this.$validator.reset();
        this.$refs.categorySelect.clearSelection();
        this.disabled = false;
      }
    },
  },
};
</script>
